// src/pages/KcbAuthResult.js

import { useEffect } from 'react';
import { AuthRelay } from '../components/AuthLayout';

// 환경에 따른 API_BASE_URL 설정
let API_BASE_URL;
if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = window.location.origin;
} else {
  API_BASE_URL = 'http://localhost:3001';
}

const safeSetLocalStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn('localStorage 저장 실패', e);
    return false;
  }
};

const KcbAuthResult = () => {
  useEffect(() => {
    // console.log('[KCB AuthResult] 컴포넌트 마운트 시작');
    // console.log('[KCB AuthResult] 현재 URL:', window.location.href);
    // console.log('[KCB AuthResult] Search params:', window.location.search);

    const params = new URLSearchParams(window.location.search);
    const result = {
      name: params.get('name'),
      tel_no: params.get('tel_no'),
      birthday: params.get('birthday'),
      sex_cd: params.get('sex_cd'),
      di: params.get('di'),
      eci: params.get('eci'),
      resultCode: params.get('resultCode'),
      resultMsg: params.get('resultMsg'),
    };

    // authType과 userIndex 파라미터 추가로 읽기
    const authType = params.get('authType');
    const userIndex = params.get('userIndex');

    // console.log('[KCB AuthResult] URL params:', {
    //   name: result.name,
    //   tel_no: result.tel_no,
    //   birthday: result.birthday,
    //   sex_cd: result.sex_cd,
    //   di: result.di,
    //   eci: result.eci,
    //   authType,
    //   userIndex,
    //   allParams: Object.fromEntries(params.entries())
    // });

    // birthday 파라미터 디버깅
    // console.log('[KCB AuthResult] birthday 파라미터 확인:');
    // console.log('- params.get("birthday"):', params.get('birthday'));
    // console.log('- params.get("rslt_birthday"):', params.get('rslt_birthday'));
    // console.log('- params.get("birth"):', params.get('birth'));
    // console.log('- params.get("birthDate"):', params.get('birthDate'));
    // console.log('- 모든 파라미터 키:', Array.from(params.keys()));

    // console.log('[KCB AuthResult] Current URL:', window.location.href);
    // console.log('[KCB AuthResult] Search params:', window.location.search);

    const debugLog = {
      result,
      opener: !!window.opener,
      origin: window.location.origin,
      timestamp: new Date().toISOString()
    };

    // console.log('[KCB AuthResult] 디버그 정보:', debugLog);

    const saveAndClose = () => {
      // console.log('[KCB popup] set kcb_auth_result:', result);
      const saveData = {
        ...result,
        authType,
        userIndex: userIndex ? parseInt(userIndex) : undefined,
        debug: debugLog
      };
      // console.log('[KCB popup] 저장할 데이터:', saveData);
      safeSetLocalStorage('kcb_auth_result', JSON.stringify(saveData));
      // console.log('[KCB popup] localStorage 저장 완료, 500ms 후 창 닫기');
      setTimeout(() => {
        // console.log('[KCB popup] 창 닫기 실행');
        window.close();
      }, 500);
    };

    if (window.opener) {
      // console.log('[KCB AuthResult] opener가 존재함, postMessage 전송 시도');
      try {
        const postMessageData = {
          rslt_name: result.name,
          tel_no: result.tel_no,
          birthday: result.birthday,
          sex_cd: result.sex_cd,
          di: result.di,
          eci: result.eci,
          resultCode: result.resultCode,
          resultMsg: result.resultMsg,
          authType: authType || 'password_reset',
          userIndex: userIndex ? parseInt(userIndex) : undefined,
          debug: debugLog
        };

        // console.log('[KcbAuthResult] postMessage 전송 데이터:', postMessageData);
        // console.log('[KcbAuthResult] postMessage 전송 대상 origin:', API_BASE_URL);

        window.opener.postMessage(
          postMessageData,
          API_BASE_URL  // ← 이 부분!!
        );

        // console.log('[KcbAuthResult] postMessage 전송 완료');

        // postMessage 성공해도 fallback 저장 및 딜레이 닫기 보장
        saveAndClose();
      } catch (e) {
        // console.error('[KcbAuthResult] postMessage 전송 실패:', e);
        debugLog.error = e?.message || e;
        saveAndClose();
        return;
      }
    } else {
      // console.log('[KCB AuthResult] opener가 존재하지 않음, localStorage만 저장');
      debugLog.opener = false;
      saveAndClose();
      return;
    }
  }, []);

  return <AuthRelay title="인증 결과를 처리 중입니다..." description="잠시 후 이 창이 자동으로 닫혀요." />;
};

export default KcbAuthResult;
